// The customer workspace's view of the §3.1 customer subscription projection
// (`GET /v1/admin/entitlement-customers/{id}/subscription`). Without `invoices.manage`
// the API nulls the amounts and the payer; modifiability is always present.
import type { AdminCustomerSubscription } from "$lib/api/contract";
import { getAdminCustomerSubscription } from "$lib/api/endpoints";

export type { AdminCustomerSubscription };

/**
 * The customer's current extension-plan subscription, or `null` when there is none.
 * The summary then falls back to the invoice-derived view — see `subscriptionView`.
 */
export function fetchCustomerSubscription(
  customerId: string,
  signal: AbortSignal
): Promise<AdminCustomerSubscription | null> {
  return getAdminCustomerSubscription(customerId, signal);
}

/** Operator-facing copy for why a subscription cannot take a modify quote. */
export function notModifiableCopy(reason: AdminCustomerSubscription["notModifiableReason"]): string {
  switch (reason) {
    case "not_admin_managed":
      return "Self-service subscriptions are changed by the customer.";
    case "not_active":
      return "Only an active subscription can be modified.";
    case "multiple_items":
      return "This subscription has more than one item.";
    case "pending_modification":
      return "A modification is already waiting to be accepted.";
    default:
      return "This subscription cannot be modified.";
  }
}
